import styled from '@emotion/styled';

const ChipsWrapper = styled('div')`
  display: flex;
  gap: 8px;
  max-width: 100%;
  flex-wrap: wrap;
  .MuiButtonBase-root {
    margin: 0;
  }
`;

export default {
  ChipsWrapper,
};
